import './SlideInOverlayFooter.scss'
import template from './SlideInOverlayFooter.vhtml';

export default {
	name: 'SlideInOverlayFooter',
	template: template,
};
